import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { CiCdConfigService } from "src/cicd/ci-cd-config.service";

@Injectable({
  providedIn: "root"
})
export class SelectsService implements OnInit {
  private SelectedError = new Subject<any>();
  eventSelectedError$ = this.SelectedError.asObservable();
  public buscarXnombre: any = {};
  public headers: any;
  public userData: any;
  private urlApi: string;

  constructor(private http: HttpClient,
    private readonly ciCd: CiCdConfigService
  ) {
    // this.urlApi = environment.urlApi; // PREJENKINS
    this.ciCdInit();
    if (localStorage.getItem("identity")) {
      this.userData = JSON.parse(localStorage.getItem("identity"));
    }

    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("token"));
  }

  ciCdInit() {
    this.ciCd.loadConfigurations().subscribe(({ apis }: any) => {
      const { urlApi } = apis;
      this.urlApi = urlApi;
    });
  }

  ngOnInit() {
    if (localStorage.getItem("identity")) {
      this.userData = JSON.parse(localStorage.getItem("identity"));
    }
    this.headers = this.headers.set("token", localStorage.getItem("token"));
  }

  sendMessage(selected: any) {
    this.SelectedError.next(selected);
  }

  GetContratoCobra(data: any, affiliate: any, state: any) {
    this.userData = JSON.parse(localStorage.getItem("identity"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("token"));
    data.tipo_documento = affiliate.tipo_documento_af;
    data.documento = affiliate.documento_af;
    data.id_pais = this.userData.v_pais;
    data.estado = state;
    const headers = this.headers;
    const options = { params: data, headers };
    return (
      this.http
        .get(`${this.urlApi}/consulta_contratos_cobra_desa`, options)
        // return this.http.get(`${this.urlApi}consulta_contratos_cobra`, options)
        .pipe(
          map((resp: any) => {
            // Se alterna para desarrollo o producción.
            // return resp.CONSULTA_CONTRATO_COBRA;
            return resp.CONSULTA_CONTRATO_COBRA_DESA;
          })
        )
    );
  }

  // 1. Tipos de documento
  gertDocumentsType() {
    return this.http.get(`${this.urlApi}/consulta_tipos_documento`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPOS_DOCUMENTO;
      })
    );
  }

  // 2. Tipos crédito
  GetTipoCredito() {
    return this.http.get(`${this.urlApi}/consulta_tipo_credito`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_CREDITO;
      })
    );
  }

  // 3. Tipo Entidad
  GetTipoEntidad() {
    return this.http.get(`${this.urlApi}/consulta_tipo_entidad`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_ENTIDAD;
      })
    );
  }

  /* <------------------- Estados -----------------> */

  // 4.1 Estado afiliado
  GetEstadoAfiliado() {
    return this.http.get(`${this.urlApi}/consulta_estado_afiliados`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_ESTADO_AFILIADOS;
      })
    );
  }

  // 4.2 Estado afiliado
  GetEstadoDirecciones() {
    return this.http.get(`${this.urlApi}/consulta_estados_direcciones`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_ESTADOS_DIRECCIONES;
      })
    );
  }

  // 4.3 Estado telefonos
  GetEstadoTelefonos() {
    return this.http.get(`${this.urlApi}/consulta_estados_telefonos`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_ESTADOS_TELEFONOS;
      })
    );
  }

  // 5. Consulta causales retiro
  GetCausalesRetiro() {
    return this.http.get(`${this.urlApi}/consulta_causales_retiro`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_CAUSALES_RETIRO;
      })
    );
  }

  // 6. Consulta tipo sociedad
  GetTipoSociedad() {
    return this.http.get(`${this.urlApi}/consulta_tipos_sociedad`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPOS_SOCIEDAD;
      })
    );
  }

  // 7. Consulta municipios
  GetDepartamentosMunicipios() {
    return this.http
      .get(`${this.urlApi}/consulta_departamento_municipios`)
      .pipe(
        map((resp: any) => {
          return resp.CONSULTA_DEPARTAMENTO_MUNICIPIOS;
        })
      );
  }

  // 7.1 Consulta municipios
  GetMunicipios(departamento: string) {
    return this.http
      .get(`${this.urlApi}/consulta_municipios?departamento=${departamento}`)
      .pipe(
        map((resp: any) => {
          return resp.CONSULTA_MUNICIPIOS;
        })
      );
  }

  // 8. Consulta tipo producto
  GetTipoProducto() {
    return this.http.get(`${this.urlApi}/consulta_tipo_producto`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_PRODUCTO;
      })
    );
  }

  // 9. Consulta tipo afiliado
  GetTipoAfiliado() {
    return this.http.get(`${this.urlApi}/consulta_tipo_afiliado`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_AFILIADO;
      })
    );
  }

  // 10. Consulta tipo carga
  GetTipoCarga() {
    return this.http.get(`${this.urlApi}/consulta_tipo_carga`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_CARGA;
      })
    );
  }

  // 11. Consulta sector economico
  GetSectorEconomico() {
    return this.http.get(`${this.urlApi}/consulta_sector_economico`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_SECTOR_ECONOMICO;
      })
    );
  }

  // 12. Consulta sector economico
  GetUnidadServicio() {
    return this.http.get(`${this.urlApi}/consulta_unidad_servicio`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_UNIDAD_SERVICIO;
      })
    );
  }

  // 13. Consulta periodo facturacion
  GetPeriodoFacturacion() {
    return this.http.get(`${this.urlApi}/consulta_periodo_facturacion`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_PERIODO_FACTURACION;
      })
    );
  }

  // 14. Consulta estados obligacion
  GetEstadosObligacion() {
    return this.http.get(`${this.urlApi}/consulta_estados_obligacion`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_ESTADOS_OBLIGACION;
      })
    );
  }

  // 15. Consulta tipo telefono
  GetTipoDireccion() {
    return this.http.get(`${this.urlApi}/consulta_tipo_direccion`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_DIRECCION;
      })
    );
  }

  // 16. Consulta tipo telefono
  GetTipoTelefono() {
    return this.http.get(`${this.urlApi}/consulta_tipo_telefono`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_TELEFONO;
      })
    );
  }

  // 17. Consulta consulta_tipos_deudor
  GetTipoDeudor() {
    return this.http.get(`${this.urlApi}/consulta_tipos_deudor`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPOS_DEUDOR;
      })
    );
  }

  // 18. Consultar tipos de contrato
  GetTipoContrato() {
    return this.http.get(`${this.urlApi}/consulta_tipos_contrato`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPOS_CONTRATO;
      })
    );
  }

  // 19. Día corte
  GetDiaCorte() {
    return this.http.get(`${this.urlApi}/consulta_dia_corte`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_DIA_CORTE;
      })
    );
  }

  // 20. Consulta motivos de anulación
  GetMotivosAnulacion() {
    return this.http.get(`${this.urlApi}/consulta_motivos_anulacion`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_MOTIVOS_ANULACION;
      })
    );
  }

  // 21. Consulta lista iva
  GetIva() {
    return this.http.get(`${this.urlApi}/consulta_lista_iva`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_LISTA_IVA;
      })
    );
  }

  // 22. Motivos anulacion
  MotivosAnulacion() {
    return this.http.get(`${this.urlApi}/consulta_motivos_anulacion`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_MOTIVOS_ANULACION;
      })
    );
  }

  // 23. Periodo facturacion
  // GetPeriodoFacturacion() {
  //   return this.http.get(`${this.urlApi}consulta_periodo_facturacion`)
  //   .pipe(
  //     map((resp: any) => {
  //       return resp.CONSULTA_PERIODO_FACTURACION;
  //     })
  //   );
  //  }

  // 24. Formas cto servicio
  GetListaCtoServicio() {
    return this.http.get(`${this.urlApi}/consulta_lista_servicios_cto`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_LISTA_SERVICIO_CTO;
      })
    );
  }

  // 25. Consulta formas cto servicio
  GetFormasCtoServicio() {
    return this.http.get(`${this.urlApi}/consulta_formas_cto_servicio`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_FORMAS_CTO_SERVICIO;
      })
    );
  }

  // 26. Departamentos
  GetDepartamentos() {
    return this.http.get(`${this.urlApi}/consulta_departamentos`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_DEPARTAMENTOS;
      })
    );
  }

  // 27. Actividad economica
  GetActividadEconomica() {
    return this.http.get(`${this.urlApi}/consulta_actividad_economica`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_ACTIVIDAD_ECONOMICA;
      })
    );
  }

  // 28. Tipo Asesor
  GetTipoAsesor() {
    return this.http.get(`${this.urlApi}/consulta_tipo_asesor`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_ASESOR;
      })
    );
  }

  // 29. consulta_estados_civil
  GetEstadoCivil() {
    return this.http.get(`${this.urlApi}/consulta_estados_civil`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_ESTADOS_CIVIL;
      })
    );
  }

  // 29. consulta_tipo_facturacion
  GetTipoFacturacion() {
    return this.http.get(`${this.urlApi}/consulta_tipo_facturacion`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_TIPO_FACTURACION;
      })
    );
  }

  // 30. consulta_tipo_facturacion
  GetFuenteTelefono() {
    return this.http.get(`${this.urlApi}/consulta_fuente_telefono`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_FUENTE_TELEFONO;
      })
    );
  }

  GetPeridoFacturacion() {
    return this.http.get(`${this.urlApi}/consulta_periodo_facturacion`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_PERIODO_FACTURACION;
      })
    );
  }

  // 31 Consulta servicios prototipos
  GetServiciosPrototipos() {
    return this.http.get(`${this.urlApi}/consulta_servicios_registro`).pipe(
      map((resp: any) => {
        return resp.CONSULTA_SERVICIOS_REGISTRO;
      })
    );
  }

  // 32 Consulta formas prototipos
  GetFormasPrototipos(servicio: string) {
    return this.http
      .get(`${this.urlApi}/consulta_formas_x_servicio?servicio=${servicio}`)
      .pipe(
        map((resp: any) => {
          return resp.CONSULTA_FORMAS_X_SERVICIO;
        })
      );
  }

  // 33. Consulta sucursales
  GetSucursales(datos: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("tokenCVE"));
    datos.pais = this.userData.v_pais;

    const options = { params: datos };
    return this.http.get(`${this.urlApi}/consulta_sucursales`, options).pipe(
      map((resp: any) => {
        return resp.CONSULTA_SUCURSALES;
      })
    );
  }

  // 34. Consulta asesores x sucursal
  GetAsesoresPorSucursal(datos: any, sucursal: any) {
    this.userData = JSON.parse(localStorage.getItem("identityCVE"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("token"));
    datos.pais = this.userData.v_pais;
    datos.sucursal = sucursal;

    const options = { params: datos };
    return this.http
      .get(`${this.urlApi}/consulta_asesores_x_sucursal`, options)
      .pipe(
        map((resp: any) => {
          return resp.CONSULTA_ASESORES_X_SUCURSAL;
        })
      );
  }

  // 35. Consulta_lista_contratos
  GetListaContratos(datos: any, afiliado: any) {
    this.userData = JSON.parse(localStorage.getItem("identity"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("token"));
    datos.pais = this.userData.v_pais;
    datos.tipo_documento = afiliado.tipo_documento;
    datos.documento = afiliado.documento;

    datos.tipo_documento = afiliado.tipo_documento_af;
    datos.documento = afiliado.documento_af;

    const options = { params: datos };
    return this.http
      .get(`${this.urlApi}/consulta_lista_contratos`, options)
      .pipe(
        map((resp: any) => {
          return resp.CONSULTA_LISTA_CONTRATOS;
        })
      );
  }

  // 36. Consulta_lista_oficinas
  GetListaOficinas(datos: any, contrato: any) {
    this.userData = JSON.parse(localStorage.getItem("identity"));
    this.headers = new HttpHeaders();
    this.headers = this.headers.set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    this.headers = this.headers.set("token", localStorage.getItem("token"));
    datos.pais = this.userData.v_pais;
    datos.contrato = contrato;
    const options = { params: datos };
    return this.http
      .get(`${this.urlApi}/consulta_lista_oficinas`, options)
      .pipe(
        map((resp: any) => {
          return resp.CONSULTA_LISTA_OFICINAS;
        })
      );
  }

  Restringir($event: any) {
    // Estos son los códigos de las teclas que son presionadas.
    const arrayCodes = [8, 9, 37, 39];
    // console.log('evento', $event);

    if (
      $event.keyCode === 91 ||
      $event.keyCode === 88 ||
      $event.keyCode === 67 ||
      $event.keyCode === 86 ||
      $event.keyCode === 13
    ) {
      return;
    } else if (
      arrayCodes.indexOf($event.keyCode) === -1 &&
      $event.key.search(/\d\b/) === -1
    ) {
      $event.preventDefault();
    }
  }
}
